import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isPoolSiteStandaloneView } from '../utils/poolSitePaths';

const DEFAULT_APP_TITLE = 'KYMA 통합 관제';

type Options = {
  poolName?: string | null;
  poolCode?: string | null;
  /** 풀 이름이 없을 때 document.title 보조 */
  pageFallback?: string;
};

/**
 * 현장 단독 접근 시 브라우저 탭에 KYMA·내부 경로명 대신 시설 이름만 표시
 */
export function usePoolSitePageChrome(options: Options): { siteStandalone: boolean } {
  const { pathname } = useLocation();
  const { authState } = useAuth();
  const isAdmin = Boolean(
    authState.isAdminPasswordVerified && authState.isAuthenticated,
  );
  const siteStandalone = isPoolSiteStandaloneView(pathname, isAdmin);

  const poolName = options.poolName?.trim() || '';
  const poolCode = options.poolCode?.trim() || '';
  const pageFallback = options.pageFallback?.trim() || '';

  useEffect(() => {
    if (!siteStandalone) return;
    const prev = document.title;
    const title = poolName || poolCode || pageFallback || '시설';
    document.title = title;
    return () => {
      document.title = prev || DEFAULT_APP_TITLE;
    };
  }, [siteStandalone, poolName, poolCode, pageFallback]);

  return { siteStandalone };
}
